export enum ViewType {
  list = 'list' as any,
  grid = 'grid' as any,
}
